// extracted by mini-css-extract-plugin
export default {"overridableIcon":"overridableIcon_overridableIcon__0PSAp"};